import type { DesfazerResponse, HistoricoRegistroResponse, RecursoDesfazivel } from '@triade/contracts';
import { useConsulta, useMutacao } from './base';

/*
 * Desfazer (Sessao 28): historico de alteracoes de um registro (ficha, valor de recuperacao, CIF) e o "Desfazer" da ultima.
 * Quem decide se da para desfazer e a API (`desfazivel`); a tela so mostra o botao.
 */

/** Historico do registro (GET /desfazer/registro): `ativo` liga a consulta (ex.: so com o dialogo aberto). */
export function useHistoricoRegistro(recurso: RecursoDesfazivel, chave: string, ativo = true) {
  return useConsulta<HistoricoRegistroResponse>(['desfazer', 'registro', recurso, chave], '/desfazer/registro', {
    query: { recurso, chave },
    ativo: ativo && chave.length > 0,
  });
}

/** Desfazer (POST /desfazer/:id). Invalida TODAS as queries (chave vazia casa com tudo): a alteracao desfeita muda varias telas. */
export function useDesfazer() {
  return useMutacao<DesfazerResponse, string>({
    metodo: 'POST',
    caminho: (id) => `/desfazer/${id}`,
    invalidar: [[]],
  });
}
